// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tdx-input[data-v-59e79a86]{position:relative}.tdx-input__input[data-v-59e79a86]{height:3.875rem;box-sizing:border-box;border-radius:.75rem;color:#1c1d20;padding:1.875rem 1.125rem .75rem}.tdx-input--focused[data-v-59e79a86],.tdx-input__input[data-v-59e79a86]{box-shadow:0 0 2px rgba(0,0,0,.15)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
